import { Theme } from '@material-ui/core';

const getChartTheme = (isSmall: boolean, theme: Theme) => {
  const fontSize = isSmall ? 10 : 11;
  const textColor = theme.palette.type === 'dark' ? 'white' : '#333';

  return {
    labels: {
      text: {
        fontSize,
        fontFamily: 'inherit',
        color: textColor,
        fill: textColor
      }
    },
    markers: { textColor },
    legends: {
      text: { fontSize }
    },
    dots: {
      text: { fontSize, fill: textColor }
    },
    axis: {
      domain: {
        line: { fill: textColor }
      },
      ticks: {
        line: { fill: textColor },
        text: { fontSize, fill: textColor }
      },
      legend: {
        text: { fontSize, fill: textColor }
      }
    },
    tooltip: {
      container: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius
      }
    }
  };
};

export default getChartTheme;
